import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { Transition } from "./transition";

export class TransitionComponent extends AbstractDisplayComponent {
    private container: Transition;

    public override init() {
        let containerConfig = {
            labelName: "intro_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 1500,
                posY: 1500,
                scale: 1,
            },
            portrait: {
                posX: 1500,
                posY: 1500,
                scale: 1,
            }
        };

        this.container = new Transition(containerConfig);
    }

    public getInstance(): Transition {
        return this.container;
    }

    public override destroy(): void {
        this.container.destroy({ children: true });
    }
    public play(): void {
        this.getInstance().play();
    }
}
